<span *ngIf="viewType == constants.results_view_summary">
    <a (click)="legacyMsg.toggle($event);" class="text-primary doc-title mb-2">{{title}}</a>
</span>
<span *ngIf="viewType != constants.results_view_summary">
    <a class="text-primary bs-dark" (click)="legacyMsg.toggle($event);">{{title}}</a>
</span>
<p-overlayPanel #legacyMsg [style]="{width:'25vw'}">
    <div class="section-header my-2">Legacy Item Download</div>
    <p> You have retrieved a Legacy bibliographic record that doesn't have a file associated with it.
        The contents of this document may be retrieved using the appropriate microfiche such as, NUDOCS 48X
        fiche or PDRI/PRI fiche.
        The microfiche address is noted below.</p>
    <p><b>Microform Addresses:</b> <br /> {{microformAddress}}</p>
    <p><b>Accession Number:</b> <br /> {{accessionNumber}}</p>
</p-overlayPanel>